import React from 'react';
import { Send, Loader2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';

/**
 * "Send a test email" card — pure presentational. Verifies a provider
 * before pointing a scope at it. Disables provider buttons whose creds
 * aren't on file yet so admins don't waste a click on a guaranteed 4xx.
 */
export function TestEmailCard({
  testEmail,
  setTestEmail,
  sendingTest,
  onSendTest,
  smtpReady,
  sesReady,
}) {
  const renderBtn = (provider, label, extraDisabled = false) => (
    <Button
      size="sm"
      variant="outline"
      onClick={() => onSendTest(provider)}
      disabled={!!sendingTest || extraDisabled}
      data-testid={`send-test-${provider}`}
      className="border-slate-700 bg-slate-800 text-slate-200 hover:bg-slate-700"
    >
      {sendingTest === provider ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />}
      {label}
    </Button>
  );

  return (
    <section className="bg-slate-900/70 border border-slate-800 rounded-2xl p-6 space-y-3" data-testid="test-email-section">
      <div className="flex items-center gap-2">
        <Send className="w-4 h-4 text-amber-400" />
        <h2 className="text-white font-semibold">Send a test email</h2>
      </div>
      <p className="text-xs text-slate-400">
        Verify a provider before pointing a scope at it.
      </p>
      <Input
        value={testEmail}
        onChange={(e) => setTestEmail(e.target.value)}
        placeholder="recipient@example.com"
        data-testid="test-email-recipient"
        className="bg-slate-800/50 border-slate-700 text-white text-sm"
      />
      <div className="flex flex-wrap gap-2">
        {renderBtn('gmail', 'Test Gmail')}
        {renderBtn('smtp', 'Test SMTP', !smtpReady)}
        {renderBtn('ses', 'Test AWS SES', !sesReady)}
      </div>
    </section>
  );
}

export default TestEmailCard;
